import BaseView from 'picnic/core/views/Base';


class View extends BaseView {
	get value() {
		return this.el.nextElementSibling.innerText;
	}

	get isChecked() {
		return this.el.checked;
	}

	events() {
		return {
			'change': this._onChange
		};
	}

	toggleCheck(state) {
		this.el.checked = state;
	}

	_onChange() {
		this.trigger('change', {
			instance: this
		});
	}

}

export default View;
